if (__DEV__) {
	module.exports = require('./Environment.dev');
} else {
	module.exports = require('./Environment.prod');
}